import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { SSLMode } from 'app/registries/consts/postgre-consts';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LinkedServiceUtils } from './linked-service.utils';

@Metamodel.model({
    name: adfModelTypeMap.greenplum.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Greenplum_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Greenplum_DisplayText)
    ]
})
export class GreenplumLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public authenticationType: AuthenticationType = AuthenticationType.Basic;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: driverVersions = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.SSL_Mode
    })
    public sslMode?: SSLMode = SSLMode.Require;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): GreenplumLinkedService {
        const copy = LinkedServiceUtils.commonV1ToV2(context, this) as GreenplumLinkedService;
        if (this.enableAKV) {
            copy.enableAKV = false;
            delete copy.referedAKV;
        } else if (this.version !== driverVersions.v2) {
            copy.authenticationType = AuthenticationType.Basic;
        }
        return copy;
    }
}
